const basePath = window.appConfig.VUE_APP_PATH;
export default [
  {
    label: '产品',
    url: '',
    child: [
      {
        label: '签署产品',
        desc: '用亲笔签，签出意愿',
        child: [
          {
            label: '亲笔签SaaS',
            url: `${basePath}saas`,
            icon: require('./img/pro1.svg'),
          },
          {
            label: '亲笔签第三方平台',
            url: `${basePath}leaflets`,
            icon: require('./img/pro2.svg'),
          },
        ],
      },
      {
        label: '笔迹+创新产品',
        desc: '用笔迹连接世界',
        child: [
          {
            label: 'AI业务经理·展示中心',
            url: `https://ai-demo.isigning.cn/#/`,
            openurl: true,
            icon: require('./img/pro3.png'),
          },
          {
            label: '签字上墙',
            url: `${basePath}signIn`,
            icon: require('./img/pro4.png'),
          },
          {
            label: '笔迹登录',
            url: `${basePath}note`,
            icon: require('./img/pro5.png'),
          },
          {
            label: '法人数字笔迹授权验证平台',
            url: `https://test.isigning.cn/bjsq`,
            openurl: true,
            icon: require('./img/pro7.png'),
          },
        ],
      },
      {
        label: '验签',
        desc: '合同真伪，一验便知',
        child: [
          {
            label: '文件验签',
            url: `${basePath}product`,
            icon: require('./img/pro6.png'),
          },
        ],
      },
      {
        label: '司法后服务',
        desc: '司法鉴定专家效率工具',
        child: [
          {
            label: '笔迹鉴定辅助系统',
            url: 'https://hwsv-helper.isigning.cn',
            openurl: true,
            icon: require('./img/bjjd.svg'),
          },
        ],
      },
    ],
  },
  {
    label: '解决方案',
    url: '',
    child: [
      {
        label: '行业解决方案',
        desc: '守护千行百业',
        child: [
          {
            label: '金融',
            url: `${basePath}solutions/finance`,
            icon: require('./img/line1.svg'),
          },
          {
            label: '教育',
            url: `${basePath}solutions/education`,
            icon: require('./img/line2.svg'),
          },
          {
            label: '人力',
            url: `${basePath}solutions/hr`,
            icon: require('./img/line3.svg'),
          },
          {
            label: '担保',
            url: `${basePath}solutions/security`,
            icon: require('./img/line4.svg'),
          },
          {
            label: '地产',
            url: `${basePath}solutions/property`,
            icon: require('./img/line5.svg'),
          },
        ],
      },
      {
        label: '公共服务解决方案',
        desc: '一件事一次办',
        child: [
          {
            label: '智慧政务',
            url: `${basePath}trade/zhengwu`,
            icon: require('./img/line6.svg'),
          },
          {
            label: '智慧交管',
            url: `${basePath}trade/jiaoguan`,
            icon: require('./img/line7.svg'),
          },
          {
            label: '智慧检务',
            url: `${basePath}trade/jianwu`,
            icon: require('./img/line8.svg'),
          },
        ],
      },
      {
        label: '体验',
        desc: '行业签署流程演示',
        child: [
          {
            label: '体验中心',
            url: `${basePath}experience`,
            icon: require('./img/line9.svg'),
          },
        ],
      },
    ],
  },
  {
    label: '开放平台',
    url: `${basePath}open`,
  },
  {
    label: '电子档案',
    url: `${basePath}eputin`,
  },
  {
    label: '生态合作',
    url: `${basePath}partner`,
  },
  // {
  //   label: '定价',
  //   url: `${basePath}econtract`,
  // },
];
